import { render, staticRenderFns } from "./DrawableForm.vue?vue&type=template&id=dc9d32d8"
import script from "./DrawableForm.vue?vue&type=script&lang=js"
export * from "./DrawableForm.vue?vue&type=script&lang=js"
import style0 from "./DrawableForm.vue?vue&type=style&index=0&id=dc9d32d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports